import { render, staticRenderFns } from "./onDisableOperationButton-editor.vue?vue&type=template&id=e473af3a&scoped=true&"
import script from "./onDisableOperationButton-editor.vue?vue&type=script&lang=js&"
export * from "./onDisableOperationButton-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e473af3a",
  null
  
)

export default component.exports